import api from 'api/instance';
import { FetchQueryType, FetchResponse } from 'types/common';

import { CollectionPoint } from 'types/location';
import { Location } from 'types/washhub';

const URL = `${process.env.REACT_APP_API_URL}`;

export const createCollectionPoint = async (payload: any) => {
  const { data } = await api.post(
    `${URL}/location/create/collection-point`,
    payload,
  );

  return data;
};

type CollectionPointsResponse = {
  items: CollectionPoint[];
  message: string;
};

export const fetchCollectionPoints = async (washHub?: string) => {
  const { data } = await api.get<CollectionPointsResponse>(
    `${URL}/location/list`,
    {
      params: {
        type: 'collection_point',
        washHub,
        limit: 1000,
      },
    },
  );

  return data?.items;
};

export const fetchWashHubLocations = async (): Promise<Location[]> => {
  const { data } = await api.get<FetchResponse<Location>>(
    `${URL}/location/list`,
    {
      params: {
        type: 'wash_hub',
        limit: 1000,
      },
    },
  );

  return data?.items ?? [];
};

export const fetchPaginatedCollectionPoints = async (
  params: FetchQueryType,
) => {
  const { data } = await api.get<FetchResponse<CollectionPoint>>(
    `${URL}/location/list`,
    {
      params: {
        type: 'collection_point',
        ...params,
      },
    },
  );

  return data;
};

export const deleteCollectionPoints = async (ids: string[]) => {
  const { data } = await api.delete(`${URL}/location/remove-many`, {
    data: { ids },
  });

  return data;
};

export const updateCollectionPoint = async (payload: any) => {
  const { _id, ..._payload } = payload;

  const { data } = await api.patch(
    `${URL}/location/collection-point/${_id}`,
    _payload,
  );

  return data;
};

type WashHubPayload = {
  _id: string;
  size: string;
  address: CollectionPoint['address'];
  name: string;
  email?: string;
  packages: Array<string>;
  phcMethod: number;
};

export const updateWashHub = async (payload: WashHubPayload) => {
  const { data } = await api.patch(
    `${URL}/location/update/${payload?._id}`,
    payload,
  );

  return data;
};
